const PERMISSION_KEY= "core:miniapp_config";
const PAGE_URL = {
    MINI_APP_CONFIG_PAGE: "/admin/core/mini-app-config"
}

export {PERMISSION_KEY, PAGE_URL}

